import type { ReactNode } from "react";
import { useI18n } from "../i18n/I18nProvider";

/**
 * Page shell shared by the submitting, failure and success states. Frames 0:1029 and 0:1045:
 * header 100 desktop and 84 mobile with the project caption and no CTA, footer 120 and 104 with
 * the TDCO logo and the location note.
 */
export function StatusShell({ children }: { children: ReactNode }) {
  const { copy, direction } = useI18n();

  return (
    <div className="flex min-h-screen flex-col bg-white">
      <header className="border-b border-[#efeef4]">
        <div
          dir="ltr"
          className="mx-auto flex h-[84px] w-full max-w-[1440px] items-center justify-between px-6 lg:h-[100px] lg:px-[72px]"
        >
          <div className="flex items-center gap-[18px]">
            <img
              src="/logos/logo-bond.png"
              alt="bond"
              width={130}
              height={42}
              className="h-[31px] w-auto lg:h-[42px]"
            />
            <img
              src="/logos/logo-tdco.png"
              alt="TDCO, Technical Dimensions Co."
              width={155}
              height={34}
              className="hidden h-[34px] w-auto lg:block"
            />
          </div>
          <div className="flex flex-col items-end gap-[6px] text-right lg:gap-[7px]">
            <span
              dir={direction}
              className="text-[18px] font-bold leading-tight text-navy lg:text-[22px]"
            >
              {copy.brand.projectName}
            </span>
            <span dir={direction} className="text-[9px] leading-tight text-body lg:text-[11px]">
              {copy.brand.projectCaption}
            </span>
          </div>
        </div>
      </header>
      <main className="flex flex-1 flex-col">{children}</main>
      <footer className="flex-none">
        <div className="flex h-[104px] flex-col items-center justify-center gap-[9px] lg:h-[120px] lg:gap-3">
          <img
            src="/logos/logo-tdco.png"
            alt="TDCO"
            width={124}
            height={28}
            className="h-[25px] w-auto lg:h-[28px]"
          />
          <p dir={direction} className="text-[10px] text-body lg:text-[11px]">
            {copy.success.footerNote}
          </p>
        </div>
      </footer>
    </div>
  );
}
